import React from 'react';
import styles from './TerritoryHeader.module.css';

interface TerritoryHeaderProps {
  territory: string;
  onNewTicket?: () => void;
}

export const TerritoryHeader: React.FC<TerritoryHeaderProps> = ({
  territory,
  onNewTicket,
}) => {
  return (
    <div className={styles.row}>
      <h2 className={styles.title}>{territory}</h2>
      <button className={styles.button} onClick={onNewTicket}>
        + New Ticket
      </button>
    </div>
  );
};
